import classNames from 'classnames';
import FilmwebLink from 'src/components/filmweblink/FilmwebLink';
import { CmsImageForUrl } from "src/components/images/CmsImageForUrl";
import ExternalImageForUrl from "src/components/images/ExternalImageForUrl";
import Image from 'src/components/images/Image';

import cssPosterStyles from "src/components/posterrow/CSSPoster.module.css";
import { getContentUrl } from 'src/lib/movieinfo/getContentUrl';
import { type ImageVersion, type WatchableContent } from 'src/lib/movieinfo/movieinfotypes';
import styles from "./ResultLandscapeImage.module.css";

//#region [Props]
type ResultLandscapeImageProps = {
    data: WatchableContent;

    forceStreaming?: boolean;
    mobileLayout?: "row" | "column";
    clickTracker?: (id: string | number, title: string) => void;
    className?: string;
};
//#endregion

//#region [Component]
export default function ResultLandscapeImage({ data, className, clickTracker, mobileLayout = "column", forceStreaming = false }: ResultLandscapeImageProps) {
    const hasSanityImage = !!data.sanityImageWideUrl;
    const hasStreamingImageArray = !hasSanityImage && (data.imagesLandscapeStreaming?.length ?? 0) > 0;
    const hasStreamingImageUrl = !hasStreamingImageArray && data.imageLandscapeStreaming;
    const hasImage = hasSanityImage || hasStreamingImageArray || hasStreamingImageUrl;


    const url = getContentUrl(data, forceStreaming);
    return (
        <article className={classNames(className, cssPosterStyles.CSSPoster, styles.SArticle, {
            [styles['row-layout']]: mobileLayout === 'row'
        })}>
            <div className={styles.SLandscapeWrapper}>
                <FilmwebLink className={styles.SImageSizer} to={url} onClick={() => clickTracker?.(data.streamingContentId, data.title!)} data-postermissingtext={data.title}>
                    {hasImage && <>
                        {hasSanityImage && <CmsImageForUrl
                            imageUrl={data.sanityImageWideUrl!}
                            alt={`Bilde for '${data.title}'`}
                            unoptimized
                            width={270} />}
                        {hasStreamingImageArray && <Image
                            image={data.imagesLandscapeStreaming as ImageVersion[]}
                            alt={`Bilde for '${data.title}'`} sizes="270px" />}
                        {hasStreamingImageUrl && <ExternalImageForUrl
                            imageUrl={data.imageLandscapeStreaming!}
                            alt={`Bilde for '${data.title}'`} />}
                    </>}
                </FilmwebLink>
            </div>
            <header className={styles.SHeader}>
                <FilmwebLink onClick={() => clickTracker?.(data.streamingContentId, data.title!)} to={url}>
                    <h1>{data.title}</h1>
                    {data.productionYear && data.productionYear !== "0" && data.productionYear !== "-1" && <p>{data.productionYear}</p>}
                </FilmwebLink>
            </header>
        </article>
    );
}
//#endregion
